/**
 * @desc 新增操作日志
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: defs.aider.OperationLogParamDto, options?: any) {
  return updateResponse(
    http(URL + `/log/operation/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
